<template>
    <div class="message-sec">
        <div class="container">
            <div class="row">
                <div class="col-md-4 v-center">
                    <div class="message-desc">
                        <h2>Rechtsgebiete</h2>
                        <p>Ich berate meine Kunden unter andere in folgenden Rechtsgebieten</p>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="message-desc">
                        <h2 class="">Zivilrecht</h2>
                        <div class="progress">
                            <div class="progress-bar cal" role="progressbar" aria-valuenow="100"
                                 aria-valuemin="0" aria-valuemax="100" style="width:100%">
                                100%
                            </div>
                        </div>
                        <h2 class="message-desc">Handels- und Wirtschaftsrecht</h2>
                        <div class="progress">
                            <div class="progress-bar cal" role="progressbar" aria-valuenow="100"
                                 aria-valuemin="0" aria-valuemax="100" style="width:100%">
                                100%
                            </div>
                        </div>
                        <h2 class="message-desc">Investitionsrecht</h2>
                        <div class="progress">
                            <div class="progress-bar cal" role="progressbar" aria-valuenow="100"
                                 aria-valuemin="0" aria-valuemax="100" style="width:100%">
                                100%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Appointment',
        components: {},
        data () {
            return {};
        },
        methods: {}
    };
</script>
